var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WxLocation',{on:{"init":_vm.getLocation,"error":_vm.getError}})
}
var staticRenderFns = []

export { render, staticRenderFns }